<template>
  <div id="home-center" ref="appRef">
    <div class="host-body">
      <!-- 时间 -->
      <div class="time-box">
        <i class="el-icon-time"></i>
        <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
      </div>

      <div class="body-box">
        <div class="content-left">
          <div class="left1">
            <div class="box-title">{{ schoolTitle }}</div>
            <div class="tips-content d-flex jc-between">
              <img src="@/assets/images/world.png" alt />
              <img src="@/assets/images/news.png" alt class="news" />
              <div class="tips">{{ schoolMessage }}</div>
            </div>
            <div class="bottom">
              超
              <span>{{ remoteNum }}</span> 次远程指导
            </div>
          </div>
          <div class="left2">
            <div class="box-title">学校关注度最高的融合教学问题</div>
            <LeftChart :cdata="problemsData" class="left-chart" />
          </div>
        </div>
        <div class="content-right">
          <div class="map-top d-flex jc-between">
            <div class="flex-1">
              <div class="type-name">学生</div>
              <div>
                <div
                  class="num-card"
                  v-for="(item, i) in studentNum.length"
                  :key="i"
                  v-text="studentNum.charAt(i)"
                ></div>
                <span class="unit">人</span>
              </div>
            </div>
            <div class="flex-1">
              <div class="type-name">学校</div>
              <div>
                <div
                  class="num-card"
                  v-for="(item, i) in schoolNum.length"
                  :key="i"
                  v-text="schoolNum.charAt(i)"
                ></div>
                <span class="unit">所</span>
              </div>
            </div>
            <div class="flex-1">
              <div class="type-name">老师</div>
              <div>
                <div
                  class="num-card"
                  v-for="(item, i) in teacherNum.length"
                  :key="i"
                  v-text="teacherNum.charAt(i)"
                ></div>
                <span class="unit">人</span>
              </div>
            </div>
          </div>
          <div class="map">
            <!-- <MapChart :cdata="mapData" /> -->
            <mapChart :name="mapName" v-if="!!mapName" />
          </div>
          <div class="map-right">
            <div>
              <h3>学校活跃度排名</h3>
              <SchoolRank :dataList="rankList" />
            </div>
            <div class="right-chart">
              <RightChart :cdata="schoolData" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import drawMixin from '@/utils/drawMixin';
import { formatTime } from '@/utils/index.js';
import LeftChart from '_c/echart/center/leftChart/chart.vue';
import RightChart from '_c/echart/center/rightChart/chart.vue';
// import MapChart from '_c/echart/center/map/chart.vue';
import SchoolRank from '_c/ranks/schoolRank.vue';
import mapChart from '_c/echart/center/map/chart.vue';
// src\components\echart\center\map\chart.vue

import { getDataByUrl } from '@/api/index.js';

export default {
  components: { LeftChart, RightChart, SchoolRank, mapChart },
  // mixins: [drawMixin],
  data() {
    return {
      userName: null,
      timing: null,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      tomorrow: null,
      schoolName: '',
      schoolTitle: '明天 8：00 — 9:00 入班观察提醒',
      schoolMessage:
        '2024学年下学期上海市青浦佳禾小学、上海市青浦阳阳幼儿园等学校',
      remoteNum: 0,

      studentNum: '0',
      schoolNum: '0',
      teacherNum: '0',
      problemsData: {
        // data: [
        //   { value: 18, name: '课程调整' },
        //   { value: 30, name: '个别化教育计划制订' },
        //   { value: 20, name: '学生评估' },
        //   { value: 17, name: '情绪行为干预' },
        //   { value: 15, name: '课程教案' }
        // ]
      },
      mapData: {},
      rankList: [
        // ['上海市青浦区辅读学校', 70, 1],
        // ['青浦佳禾小学', 39, 2],
        // ['上海市青浦阳阳幼儿园', 20, 3]
      ],
      schoolData: {
        // legends: ['小学', '初中'],
        // xAxisData: [
        //   '2023.07',
        //   '2024.08',
        //   '2024.09',
        //   '2024.10',
        //   '2024.11',
        //   '2024.12'
        // ],
        // yAxisDataArr: [
        //   {
        //     seriesName: '小学',
        //     seriesData: [80, 95, 120, 138, 151, 160]
        //   },
        //   {
        //     seriesName: '初中',
        //     seriesData: [55, 83, 92, 105, 110, 119]
        //   }
        // ]
      },
      mapName: ''
    };
  },
  mounted() {
    this.initData();
    this.timeFn();
  },
  unMounted() {
    clearInterval(this.timing);
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.getTips();
      this.getProblems();
      this.getNums();
      this.getRanks();
      this.getSchoolStudentsData();
      this.getMapData();
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss');
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    getTips() {
      getDataByUrl('remind').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          if (data) {
            this.schoolTitle = data.title;
            this.schoolMessage = data.content;
            this.remoteNum = data.contentCount;
          }
        }
      });
    },
    getProblems() {
      getDataByUrl('teachingProblem').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          if (data) {
            let dataArr = data.map((item) => {
              return {
                name: item.type,
                value: item.count
              };
            });
            this.problemsData = {
              data: dataArr
            };
          }
        }
      });
    },
    getNums() {
      getDataByUrl('overview').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          if (data) {
            this.studentNum = data.studentCount + '';
            this.schoolNum = data.schoolCount + '';
            this.teacherNum = data.teacherCount + '';
          }
        }
      });
    },
    getRanks() {
      getDataByUrl('liveness').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          if (data) {
            this.rankList = data.map((item) => {
              return [item.type, item.count, item.rank];
            });
          }
        }
      });
    },
    getSchoolStudentsData() {
      getDataByUrl('student/month').then((res) => {
        if (res.code === '0') {
          let data = res.data || [];
          if (data) {
            data = data.sort((a, b) => new Date(a.time) - new Date(b.time));
            let legends = [...new Set(data.map((item) => item.type))];
            let xAxisData = [...new Set(data.map((item) => item.time))];
            let yAxisDataArr = legends.map((legend) => {
              return {
                seriesName: legend,
                seriesData: data
                  .filter((item) => item.type === legend)
                  .map((item) => item.count)
              };
            });
            // 获取cout最大值
            let maxCount = Math.max(...data.map((item) => item.count));
            this.schoolData = {
              legends: legends,
              xAxisData: xAxisData,
              yAxisDataArr: yAxisDataArr,
              max: parseInt(maxCount * 1.2) // 设置y轴最大值为最大count的1.2倍
            };
          }
        }
      });
    },
    getMapData() {
      getDataByUrl('mapInfo').then((res) => {
        if (res.code === '0') {
          this.mapName = res?.data?.mapName || 'china';
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#home-center {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // transform-origin: left top;

  color: #d3d6dd;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  // background-color: #0a1531;

  .host-body {
    padding-top: 170px;

    .time-box {
      width: 538px;
      text-align: center;
      font-size: 26px;
      color: #ffffff;
      i {
        margin-right: 20px;
      }
    }
    $borderColor: #17caf0;
    .body-box {
      margin-top: 16px;
      display: flex;
      .content-left {
        width: 538px;
        height: 832px;
        background-image: url(~@/assets/images/center-left-border.png);
        .left1 {
          height: 390px;
          border-bottom: 1px dashed #1b60cc;
          overflow: hidden;
          .tips-content {
            position: relative;
            margin-top: 35px;
            padding: 0 60px;
            .news {
              position: absolute;
              left: 20px;
              top: 50px;
            }
            .tips {
              padding-left: 14px;
              font-size: 20px;
              line-height: 30px;
            }
          }
          .bottom {
            margin: 20px auto;
            width: 429px;
            height: 78px;
            font-size: 24px;
            text-align: center;
            line-height: 78px;
            background-image: url(~@/assets/images/circle-bg.png);
            span {
              font-size: 40px;
              font-weight: 500;
              color: #f3c824;
            }
          }
        }
        .box-title {
          position: relative;
          margin-left: 50px;
          margin-top: 40px;
          width: 441px;
          height: 61px;
          line-height: 61px;
          background-image: url(~@/assets/images/center-left-title.png);
          font-size: 28px;
          color: #3fd1ff;
          padding-left: 20px;
          /*强制文本在一行内显示*/
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .left2 {
          position: relative;
          overflow: hidden;
          .left-chart {
            width: 100%;
          }
        }
      }
      .content-right {
        position: relative;
        margin-left: 40px;
        flex: 1;

        .map-top {
          width: 950px;
          height: 220px;
          color: #fff;
          font-size: 24px;
          font-weight: bolder;
          .num-card {
            display: inline-block;
            width: 50px;
            height: 67px;
            background: linear-gradient(0deg, #06296a, rgba(6, 41, 106, 0));
            border: 1px solid rgba(0, 182, 255, 0.8);
            border-radius: 3px;
            line-height: 67px;
            text-align: center;
            color: #fdcc00;
            font-size: 50px;
            // background-color: #08266f;
            margin-right: 10px;
            margin-top: 20px;
          }
          .unit {
            vertical-align: bottom;
          }
        }
        .map {
          width: 770px;
          height: 600px;
        }
        .map-right {
          position: absolute;
          top: -46px;
          right: 10px;
          h3 {
            font-size: 26px;
            text-align: center;
            margin-bottom: 30px;
            color: #fff;
          }

          .right-chart {
            position: absolute;
            right: 0px;
            top: 450px;
            width: 570px;
          }
        }
      }
    }
  }
}
</style>
